import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      width: 16px;\n      height: 16px;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 6px;\n    width: 24px;\n    height: 24px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 6px;\n    width: 32px;\n    height: 32px;\n    font-size: 18px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 6px;\n    width: 36px;\n    height: 36px;\n    font-size: 18px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 10px;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: #ffffff;\n  font-size: 22px;\n  ", "\n  ", "\n  ", "\n  svg {\n    width: 22px;\n    height: 22px;\n    ", "\n  }\n  div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  > * {\n    transition: 0.4s;\n    opacity: 0.3;\n  }\n  &:hover {\n    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);\n    > * {\n      opacity: 1;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Wrapper = styled.div(_templateObject());
export var Button = styled.button(_templateObject2(), media.xxLargeScreen(_templateObject3()), media.mediumScreen(_templateObject4()), media.smallScreen(_templateObject5()), media.xxLargeScreen(_templateObject6()));